import { Box, IconButton, Tooltip } from '@chakra-ui/react';
import { FiSearch as SearchIcon } from '@react-icons/all-files/fi/FiSearch';
import { FC } from 'react';

type Props = {
  onClick: Function;
}

export const SearchButton: FC<Props> = ({ onClick }) => (
  <Box display="flex" justifyContent="right">
    <Box flex="0 0 40px" ml="auto">
      <Tooltip label="Search" hasArrow>
        <IconButton
          variant="ghost"
          aria-label="Search"
          fontSize="25px"
          icon={<SearchIcon color="var(--color-text-secondary)" />}
          onClick={() => onClick()}
        />
      </Tooltip>
    </Box>
  </Box>
);
